var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M8.1248,17.49901H1.8752c-1.03502,0-1.87432,.83865-1.8752,1.87375v18.75189c0,1.03573,.83955,1.87535,1.8752,1.87535h6.2496c1.03564,0,1.8752-.83962,1.8752-1.87535h0V19.37276c-.00088-1.0351-.84018-1.87375-1.8752-1.87375Zm-3.1248,19.37595c-1.03564-.00265-1.87304-.84442-1.87039-1.88014,.00265-1.03572,.84435-1.8732,1.87999-1.87054,1.03376,.00265,1.8704,.84149,1.8704,1.87534,0,1.03573-.83955,1.87535-1.87519,1.87536-.0016,0-.00321,0-.00481,0ZM30,6.36052c0,3.31386-2.0288,5.17321-2.6,7.38779h7.9472c2.52286,.00683,4.58362,2.01744,4.6528,4.53956-.0041,1.42573-.54641,2.79733-1.5184,3.84031l-.008,.008c.82894,2.05843,.55532,4.39705-.7264,6.20849,.60646,2.0374,.12297,4.24352-1.28,5.84046,.36547,1.17586,.18961,2.45333-.48,3.48668-1.5968,2.29619-5.5488,2.32819-8.8912,2.32819h-.216c-3.25671-.13752-6.4443-.98335-9.3408-2.4786-1.28622-.65996-2.67875-1.08788-4.1136-1.2641-.51094-.00959-.92009-.42661-.92-.93768V18.6175c.00013-.25018,.10038-.48989,.2784-.66565,3.0896-3.05784,4.4192-6.2965,6.9568-8.8343,1.06292-1.32776,1.74829-2.91752,1.984-4.60197C22.072,3.07546,22.7984,.00001,24.376,.00001c1.8736-.0032,5.624,.62245,5.624,6.36051Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e37ab794f139e5dd4988972dcf403391.svg";
export { ForwardRef as ReactComponent };